import React, { useEffect, useState } from 'react';
import { User, MapPin, MessageCircle, Phone, DollarSign, AlertTriangle, CheckCircle, XCircle, Camera, Clock, Shield, Menu, X, Play, PlayCircle, Download } from 'lucide-react';
import DigJekIcon from '../../Assets/digjek.png';


const TaxiRideDoc = () => {
    const [activeStep, setActiveStep] = useState(1);
    const [isOpen, setIsOpen] = useState(false);
    const [showVideoModal, setShowVideoModal] = useState(false);
    const [showTrialModal, setShowTrialModal] = useState(false);

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    const steps = [
        {
            id: 1,
            title: "Top Up Saldo Minimal",
            icon: <DollarSign className="w-6 h-6" />,
            description: "Driver dan customer harus top up saldo minimal Rp 10.000",
            details: [
                "Driver akan muncul terlacak di map setelah saldo terisi",
                "Customer baru bisa melakukan orderan setelah saldo terisi",
                "Minimum top up: Rp 10.000"
            ]
        },
        {
            id: 2,
            title: "Deteksi Driver Terdekat",
            icon: <MapPin className="w-6 h-6" />,
            description: "Customer membuka aplikasi dan driver terdeteksi berdasarkan jarak terdekat",
            details: [
                "Sistem otomatis mendeteksi lokasi customer",
                "Driver ditampilkan berdasarkan pilihan jarak",
                "Real-time tracking driver aktif"
            ]
        },
        {
            id: 3,
            title: "Pemilihan Driver & Rute",
            icon: <User className="w-6 h-6" />,
            description: "Customer memilih driver dan menentukan titik jemput serta tujuan",
            details: [
                "Pilih driver dari daftar yang tersedia",
                "Tentukan titik jemput di peta",
                "Tentukan titik tujuan di peta",
                "Isi pesan dan nomor WhatsApp",
                "Perhitungan biaya: Jarak (km) × Rp 2.000",
                "Paket pengiriman: Biaya per km + Rp 4.000 per paket"
            ]
        },
        {
            id: 4,
            title: "Melakukan Order",
            icon: <CheckCircle className="w-6 h-6" />,
            description: "Customer melakukan konfirmasi order dengan estimasi biaya",
            details: [
                "Review detail orderan",
                "Konfirmasi estimasi biaya",
                "Kirim order ke driver"
            ]
        },
        {
            id: 5,
            title: "Notifikasi Driver",
            icon: <AlertTriangle className="w-6 h-6" />,
            description: "Driver menerima notifikasi real-time dan memilih respons",
            details: [
                "Notifikasi real-time masuk ke driver",
                "Driver dapat menerima atau menolak orderan",
                "Driver dapat mengajukan negosiasi harga"
            ]
        },
        {
            id: 6,
            title: "Penolakan Order",
            icon: <XCircle className="w-6 h-6" />,
            description: "Jika driver menolak, customer mendapat notifikasi",
            details: [
                "Customer menerima alert penolakan",
                "Customer dapat membuat order baru"
            ]
        },
        {
            id: 7,
            title: "Negosiasi Harga",
            icon: <MessageCircle className="w-6 h-6" />,
            description: "Proses negosiasi antara driver dan customer",
            details: [
                "Driver mengajukan harga negosiasi",
                "Notifikasi negosiasi masuk ke customer",
                "Customer dapat menerima atau menolak"
            ]
        },
        {
            id: 8,
            title: "Respons Negosiasi",
            icon: <CheckCircle className="w-6 h-6" />,
            description: "Customer merespons negosiasi driver",
            details: [
                "Jika customer menolak: orderan berhenti",
                "Jika customer menerima: orderan dilanjutkan",
                "Konfirmasi final dari kedua belah pihak"
            ]
        },
        {
            id: 9,
            title: "Order Diterima",
            icon: <User className="w-6 h-6" />,
            description: "Setelah order diterima, fitur pembatalan masih tersedia",
            details: [
                "Order resmi diterima driver",
                "Fitur batal tersedia untuk customer dan driver",
                "Driver bersiap menuju lokasi jemput"
            ]
        },
        {
            id: 10,
            title: "Pembatasan Fitur Batal",
            icon: <Clock className="w-6 h-6" />,
            description: "Fitur batal hilang setelah driver bergerak 1 km",
            details: [
                "Tracking pergerakan driver real-time",
                "Fitur batal hilang setelah driver bergerak 1 km",
                "Komitmen order menjadi final"
            ]
        },
        {
            id: 11,
            title: "Fitur Aktif Selama Perjalanan",
            icon: <Phone className="w-6 h-6" />,
            description: "Fitur yang tersedia selama perjalanan berlangsung",
            details: [
                "Fitur Selesai: untuk menyelesaikan orderan",
                "Fitur Chat via WhatsApp: komunikasi langsung",
                "Fitur Lapor Orderan Fiktif: untuk melaporkan kecurangan"
            ]
        },
        {
            id: 12,
            title: "Penyelesaian Order",
            icon: <DollarSign className="w-6 h-6" />,
            description: "Penyelesaian orderan dan informasi pendapatan",
            details: [
                "Driver menyelesaikan orderan",
                "Informasi pendapatan ditampilkan",
                "Saldo driver terupdate otomatis",
            ]
        },
        {
            id: 13,
            title: "Laporan Orderan Fiktif",
            icon: <Camera className="w-6 h-6" />,
            description: "Sistem pelaporan untuk orderan fiktif",
            details: [
                "Driver input laporan dan alasan",
                "Upload bukti foto selfie di lokasi",
            ]
        },
        {
            id: 14,
            title: "Verifikasi Admin",
            icon: <Shield className="w-6 h-6" />,
            description: "Proses verifikasi orderan fiktif oleh admin",
            details: [
                "Admin verifikasi laporan driver",
                "Jika terbukti: saldo customer dipotong, laporan diterima",
                "Jika tidak terbukti: laporan ditolak",
                "Sistem keadilan untuk kedua belah pihak"
            ]
        }
    ];

    useEffect(() => {
        setShowTrialModal(false);
    }, []);


    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
            <div className="container mx-auto px-4 py-4">

                {/* Tombol Toggle Sidebar untuk Mobile */}
                <div className="lg:hidden fixed top-4 right-4 z-50">
                    <button
                        onClick={toggleSidebar}
                        className="bg-blue-600 text-white p-2 rounded-lg shadow hover:bg-blue-700 transition-colors"
                    >
                        {isOpen ? (
                            <X className="w-5 h-5" />
                        ) : (
                            <Menu className="w-5 h-5" />
                        )}
                    </button>
                </div>


                <div className="text-center mb-12">
                    {/* Logo */}
                    <img
                        src={DigJekIcon}
                        alt="Logo DigJek"
                        className="mx-auto w-20 h-20 rounded-full border-4 border-white"
                    />

                    {/* Judul dan deskripsi */}
                    <h1 className="text-3xl font-bold text-gray-800 mb-4">
                        Cara Penggunaan DigJek
                    </h1>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-6">
                        Panduan lengkap penggunaan aplikasi ojek online dari top up saldo hingga penyelesaian orderan
                    </p>

                    <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4 text-center">
                        {/* Tombol Video Tutorial */}
                        <button
                            onClick={() => setShowVideoModal(true)}
                            className="inline-flex items-center gap-3 bg-red-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-red-700 transition-all duration-200 shadow-lg hover:shadow-xl"
                        >
                            <Play className="w-5 h-5" />
                            Tonton Video Tutorial
                        </button>

                        {/* Tombol Download Playstore  */}
                        <a
                            href={`${process.env.REACT_APP_PLAYSTORE_URL}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-3 bg-gradient-to-r from-blue-500 to-indigo-700 text-white px-6 py-3 rounded-lg font-semibold shadow-md hover:from-blue-600 hover:to-indigo-800 transition-all duration-200 hover:shadow-xl"
                        >
                            <Download className="w-5 h-5" />
                            Download di Play Store
                        </a>

                    </div>


                </div>

                <div className="grid lg:grid-cols-4 gap-8">
                    {/* Sidebar */}
                    <div
                        className={`
                        fixed inset-y-0 left-0 z-40 w-64 bg-white p-6 transform transition-transform duration-300
                        ${isOpen ? "translate-x-0" : "-translate-x-full"}
                        lg:static lg:translate-x-0 lg:col-span-1
                        overflow-y-auto max-h-screen
                        `}
                    >

                        <h3 className="font-semibold text-gray-800 mb-4">Langkah-langkah</h3>
                        <div className="space-y-2">
                            {steps.map((step) => (
                                <button
                                    key={step.id}
                                    onClick={() => {
                                        setActiveStep(step.id);
                                        setIsOpen(false); // Tutup sidebar di mobile saat klik langkah
                                    }}
                                    className={`w-full text-left p-3 rounded-lg transition-all duration-200 flex items-center gap-3 ${activeStep === step.id
                                        ? "bg-blue-100 text-blue-700 border border-blue-200"
                                        : "hover:bg-gray-50 text-gray-600"
                                        }`}
                                >
                                    <div
                                        className={`flex-shrink-0 ${activeStep === step.id ? "text-blue-600" : "text-gray-400"
                                            }`}
                                    >
                                        {step.icon}
                                    </div>
                                    <div>
                                        <div className="font-medium text-sm">Langkah {step.id}</div>
                                        <div className="text-xs opacity-75">{step.title}</div>
                                    </div>
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Main Content */}
                    <div className="lg:col-span-3">
                        <div className="bg-white overflow-hidden">
                            {/* Header */}

                            <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white p-8">
                                <div className="flex items-center gap-4">
                                    <div className="bg-white/20 p-3 rounded-lg">
                                        {steps.find(s => s.id === activeStep)?.icon}
                                    </div>
                                    <div className="flex-1">
                                        <div className="text-blue-100 text-sm font-medium">
                                            Langkah {activeStep} dari {steps.length}
                                        </div>
                                        <h2 className="text-2xl font-bold">
                                            {steps.find(s => s.id === activeStep)?.title}
                                        </h2>
                                    </div>
                                    {/* Video Button in Header */}
                                    {/* <button
                                        onClick={() => setShowVideoModal(true)}
                                        className="bg-white/10 hover:bg-white/20 p-2 rounded-lg transition-colors duration-200"
                                        title="Lihat Video Tutorial"
                                    >
                                        <Play className="w-5 h-5" />
                                    </button> */}
                                </div>
                            </div>

                            {/* Content */}
                            <div className="p-8">
                                <p className="text-lg text-gray-700 mb-6">
                                    {steps.find((s) => s.id === activeStep)?.description}
                                </p>

                                <div className="bg-gray-50 rounded-lg p-6">
                                    <h4 className="font-semibold text-gray-800 mb-4 flex items-center gap-2">
                                        <CheckCircle className="w-5 h-5 text-green-600" />
                                        Detail Langkah
                                    </h4>
                                    <ul className="space-y-3">
                                        {steps
                                            .find((s) => s.id === activeStep)
                                            ?.details.map((detail, index) => (
                                                <li key={index} className="flex items-start gap-3">
                                                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                                                    <span className="text-gray-700">{detail}</span>
                                                </li>
                                            ))}
                                    </ul>
                                </div>

                                {/* Navigation Buttons */}
                                <div className="items-center mt-8 pt-6 border-t border-gray-200">
                                    {/* Tombol - di-center */}
                                    <div className="flex justify-center space-x-4">
                                        <button
                                            onClick={() => setActiveStep(Math.max(1, activeStep - 1))}
                                            disabled={activeStep === 1}
                                            className={`px-3 py-1.5 rounded-lg font-medium transition-all duration-200 ${activeStep === 1
                                                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                                                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                                                }`}
                                        >
                                            ← Back
                                        </button>

                                        <button
                                            onClick={() =>
                                                activeStep === steps.length
                                                    ? setActiveStep(1)
                                                    : setActiveStep(Math.min(steps.length, activeStep + 1))
                                            }
                                            className={`px-3 py-1.5 rounded-lg font-medium transition-all duration-200 ${activeStep === steps.length
                                                ? "bg-green-600 text-white"
                                                : "bg-blue-600 text-white hover:bg-blue-700"
                                                }`}
                                        >
                                            {activeStep === steps.length ? "Ulangi Tutorial" : "Next →"}
                                        </button>
                                    </div>

                                    {/* Progress Bar */}
                                    <div className="flex-1 mt-7 mx-8">
                                        <div className="bg-gray-200 rounded-full h-2">
                                            <div
                                                className="bg-gradient-to-r from-blue-500 to-indigo-500 h-2 rounded-full transition-all duration-300"
                                                style={{ width: `${(activeStep / steps.length) * 100}%` }}
                                            ></div>
                                        </div>
                                        <div className="text-center text-sm text-gray-500 mt-2">
                                            {activeStep} / {steps.length} langkah selesai
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>


                {/* Video Modal */}
                {showVideoModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
                        <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden">
                            {/* Modal Header */}
                            <div className="flex justify-between items-center p-6 border-b border-gray-200">
                                <h3 className="text-xl font-bold text-gray-800">Video Tutorial DigJek</h3>
                                <button
                                    onClick={() => setShowVideoModal(false)}
                                    className="p-2 hover:bg-gray-100 rounded-lg transition-colors duration-200"
                                >
                                    <X className="w-6 h-6" />
                                </button>
                            </div>

                            {/* Video Content */}
                            <div className="p-6">
                                <div className="relative w-full pb-[56.25%] h-0">
                                    <iframe
                                        className="absolute top-0 left-0 w-full h-full rounded-lg"
                                        src="https://www.youtube.com/embed/PgSiUO0KDcc?si=DyzP_3jpmGxdR2H5"
                                        title="Tutorial DigJek"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowFullScreen
                                    ></iframe>
                                </div>

                                {/* Video Description */}
                                <div className="mt-6 p-4 bg-gray-50 rounded-lg">
                                    <h4 className="font-semibold text-gray-800 mb-2">Tentang Video Ini</h4>
                                    <p className="text-gray-600 text-sm">
                                        Video tutorial lengkap menjelaskan cara menggunakan aplikasi DigJek untuk pengguna baru.  </p>
                                </div>
                            </div>

                            {/* Modal Footer */}
                            <div className="px-6 pb-6">
                                <div className="flex flex-col sm:flex-row gap-3">
                                    <button
                                        onClick={() => {
                                            setShowVideoModal(false);
                                            setActiveStep(1);
                                        }}
                                        className="flex-1 bg-blue-600 text-white px-4 py-2 rounded-lg font-medium hover:bg-blue-700 transition-colors duration-200"
                                    >
                                        Mulai Tutorial
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Overlay untuk sidebar mobile */}
                {isOpen && (
                    <div
                        className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
                        onClick={() => setIsOpen(false)}
                    ></div>
                )}

                {showTrialModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
                        <div className="bg-white rounded-xl shadow-lg max-w-md w-full p-6 space-y-4">
                            <div className="flex justify-between items-center">
                                <h2 className="text-xl font-bold text-gray-800">Coba Akun Trial</h2>
                                <button onClick={() => setShowTrialModal(false)} className="text-gray-500 hover:text-gray-700">
                                    <X className="w-5 h-5" />
                                </button>
                            </div>
                            <div>
                                <h3 className="font-semibold text-gray-700">Akun Customer:</h3>
                                <p className="text-sm text-gray-600">📧 Email: <strong>for.latihan7@yopmail.com</strong></p>
                                <p className="text-sm text-gray-600">🔐 Password: <strong>P@ssw0rd7</strong></p>
                            </div>
                            <div>
                                <h3 className="font-semibold text-gray-700">Akun Driver:</h3>
                                <p className="text-sm text-gray-600">📧 Email: <strong>for.latihan6@yopmail.com</strong></p>
                                <p className="text-sm text-gray-600">🔐 Password: <strong>P@ssw0rd6</strong></p>
                            </div>
                            <button
                                onClick={() => setShowTrialModal(false)}
                                className="w-full bg-blue-600 text-white py-2 rounded-lg font-medium hover:bg-blue-700 transition"
                            >
                                Tutup
                            </button>
                        </div>
                    </div>
                )}

            </div>
        </div>

    );
};

export default TaxiRideDoc;
